import { IS_USERCOM_ACTIVE } from '~/modules/usercom';

const usercomId = IS_USERCOM_ACTIVE ? 'usercom_id' : '';

export default `
#graphql
fragment CartConsents on Consents {
  ${usercomId}
  consent_to_rules
  consent_to_phone_commercials
  consent_to_email_commercials
}
`;
